namespace Ir.Components.Workbook.ToolBar.WidgetsToolBar {
    interface IWidgetsToolBarViewModel {
        config: WorkbookConfig;
        dxToolbarConfig: DevExpress.ui.dxToolbar.Properties;

        dxCopyFromPopoverConfig: DevExpress.ui.dxPopover.Properties;
        dxCopyFromPopoverComponent: DevExpress.ui.dxPopover;
        dxCopyFromTreeListConfig: DevExpress.ui.dxTreeList.Properties;
        dxCopyFromTreeListComponent: DevExpress.ui.dxTreeList;
        copyFromDataSource: Array<IItemDataSource>;
    }

    interface IItemDataSource {
        id: number;
        parentId: number;
        key: string;
        parentKey: string;
        name: string;
        tabType: TabTypeEnum;
        widgetType: WidgetType;
        selectable: boolean;
        isWidget: boolean;
    }

    export function getViewModel(this: IWidgetsToolBarViewModel, params: any, componentInfo) {
        let self = this;

        this.config = params.config as WorkbookConfig;
        this.dxToolbarConfig = {
            items: getItems(self),
        };

        this.dxCopyFromPopoverConfig = {
            showTitle: false,
            position: "bottom",
            width: 300,
            height: 300,
            visible: false,
            onShowing(e) {
                getCopyFromDataSource(self);
            },
            onInitialized(e) {
                self.dxCopyFromPopoverComponent = e.component;
            }
        };

        this.dxCopyFromTreeListConfig = {
            dataSource: null,
            keyExpr: 'key',
            parentIdExpr: 'parentKey',
            width: "100%",
            height: "100%",
            showColumnHeaders: false,
            columns: [{
                dataField: "name",
                cellTemplate(container, options) {
                    let item = options.data as IItemDataSource;
                    if (item.tabType === TabTypeEnum.Dashboard) {
                        container.append(`<i class="mi">dashboard</i> ${item.name}`);
                    }
                    else {
                        
                        container.append(`<i class="ms">${BaseWidget.getWidgetIcon(item.widgetType)}</i> ${item.name}`);
                    }
                }
            }],
            onInitialized(e) {
                self.dxCopyFromTreeListComponent = e.component;
            },
            onCellClick(e) {
                let item = e.data as IItemDataSource;
                if (item.selectable) {
                    let tabId = item.isWidget ? item.parentId : item.id;
                    let widgetId = item.isWidget ? item.id : null;
                    workbook.workbookConfig.activeTab().dashboard.copyFrom(item.widgetType, tabId, widgetId);
                    self.dxCopyFromPopoverComponent.hide();
                }
            }
        }
    }

    function getToolbarSeparator() {
        return {
            locateInMenu: 'auto',
            location: 'before',
            template(itemData, itemIndex, element) {
                $('<div>')
                    .addClass('toolbar-separator')
                    .appendTo(element);
            },
            menuItemTemplate(itemData, itemIndex, element) {
                $('<div>')
                    .addClass('toolbar-menu-separator')
                    .appendTo(element);
            },
            visible: workbook.workbookConfig.generalSettings.editing
        };
    }

    function getItems(self: IWidgetsToolBarViewModel) {
        let config = self.config;
        let items = [{
            location: 'before',
            widget: 'dxButton',
            options: {
                hint: `Dashboard Settings`,
                template: `<i class="ms">settings_panorama</i> Settings`,
                onClick(e) {
                    Ir.Components.Workbook.Settings.DashboardSettings.show(e.element);
                }
            },
            visible: config.generalSettings.editing
        }, getToolbarSeparator()] as any;

        for (const widgetType in WidgetType) {
            if (isNaN(Number(widgetType))) {
                let widgetValue: WidgetType = WidgetType[widgetType] as any;
                if (widgetValue !== WidgetType.None) {
                    if (widgetValue === WidgetType.Report || widgetValue === WidgetType.Chart || widgetValue === WidgetType.Pivot) {
                        let popoverClass = `intro-report-template-list-${widgetType.toLowerCase()}`;
                        items.push({
                            location: 'before',
                            cssClass: "intro-dashboard-widget-types",
                            locateInMenu: "auto",
                            template: () => {
                                let $element = $(`<create-report-toolbar params="isWidgetButton: true, widgetType: widgetType, popoverClass: '${popoverClass}'"></create-report-toolbar>`);

                                ko.applyBindings({
                                    widgetType: widgetValue
                                }, $element[0]);
                                return $element;
                            },
                            visible: config.generalSettings.editing
                        });
                    }
                    else {
                        items.push({
                            location: 'before',
                            cssClass: "intro-dashboard-widget-types",
                            locateInMenu: "auto",
                            widget: 'dxButton',
                            options: {
                                hint: `Add a new ${BaseWidget.getWidgetText(widgetValue)} Widget`,
                                template: `<i class="ms">${BaseWidget.getWidgetIcon(widgetValue)}</i> ${BaseWidget.getWidgetText(widgetValue)}`,
                                onClick(e) {
                                    workbook.workbookConfig.activeTab().dashboard.addWidget(widgetValue);
                                },
                                width: widgetValue === WidgetType.TreeMap ? 82 : undefined
                            },
                            visible: config.generalSettings.editing
                        });
                    }
                }
            }
        }

        items.push(getToolbarSeparator());

        items.push({
            location: 'before',
            locateInMenu: "auto",
            widget: 'dxButton',
            options: {
                hint: 'Copy From',
                template: `<i class="ms">copy_all</i> Copy From`,
                onClick(e) {
                    self.dxCopyFromPopoverComponent.option("target", e.element);
                    self.dxCopyFromPopoverComponent.show();
                },
                elementAttr: {
                    class: "intro-widget-copy-from"
                },
                width: 100
            },
            visible: config.generalSettings.editing
        });

        let pdfOptions = [
            {
                icon: 'picture_as_pdf',
                name: 'PDFLandscape',
                title: 'Landscape',
                tooltip: 'PDF Landscape'
            },
            {
                icon: 'picture_as_pdf',
                name: 'PDFTemplate',
                title: 'Template',
                tooltip: 'PDF Template',
            }
        ];
        if (!isMobile()) {
            pdfOptions.push({
                icon: 'print',
                name: 'Print',
                title: 'Print',
                tooltip: 'Print'
            });
        }

        items.push({
            location: 'after',
            locateInMenu: "auto",
            widget: 'dxDropDownButton',
            options: {
                width: 90,
                displayExpr: "title",
                items: pdfOptions,
                splitButton: true,
                hint: 'PDF Portrait',
                text: 'PDF',
                icon: 'ms-icon',
                onButtonClick(e) {
                    workbook.workbookConfig.activeTab().dashboard.exportToPDF(false, null);
                },
                onItemClick(e) {
                    switch (e.itemData.name) {
                        case "PDFLandscape":
                            workbook.workbookConfig.activeTab().dashboard.exportToPDF(true, null);
                            break;
                        case "PDFTemplate":
                            workbook.workbookConfig.workbookHelper.showPDFTemplate((pdfTemplateId, landscape) => {
                                workbook.workbookConfig.activeTab().dashboard.exportToPDF(landscape, pdfTemplateId);
                            });
                            break;
                        case "Print":
                            workbook.workbookConfig.activeTab().dashboard.print();
                            break;
                        default:
                    }
                },
                itemTemplate(itemData) {
                    let $div = $('<div>').css("height", 26).css("padding-top", 3)
                    $div.append($('<i>')
                        .text(itemData.icon)
                        .addClass('ms'));
                    $div.append($('<span>')
                        .text(itemData.title).attr("title", itemData.tooltip));
                    return $div;
                },
                onContentReady(e) {
                    $(".dx-icon-ms-icon", e.element).append("picture_as_pdf").addClass("ms").removeClass("dx-icon-ms-icon dx-icon");
                }
            },
            visible: loggedUser.permissions.printExportPDF()
        });
        items.push({
            location: 'after',
            locateInMenu: "auto",
            widget: 'dxButton',
            template: function () {
                let template = $(`<send-emailnow-button params="activeTab: $data.activeTab"></send-emailnow-button>`);
                ko.applyBindings({ activeTab: config.activeTab }, template.get(0));
                return template;
            },
            visible: ko.computed(function () {
                return loggedUser.permissions.sendEmail() && (loggedUser.permissions.printExportPDF() || loggedUser.permissions.exportExcelCSV())
            })
        });

        return items;
    }

    function getCopyFromDataSource(self: IWidgetsToolBarViewModel) {
        let o = {
            url: urlConfigs.dashboard + "GetTabsWidgets",
            data: { workbookId: workbook.workbookConfig.workbookId() },
            dataType: "json",
        } as RequestServerParams;
        o.successFunction = function (result, e) {
            self.dxCopyFromTreeListComponent.option("dataSource", result);
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get tabs and widgets";
            self.dxCopyFromTreeListComponent.option("dataSource", []);
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
}